<template>
    <div @click="onChecked" style="margin-bottom:5px;cursor:pointer">
        <span class="checkbox glyphicon" :class="{'active glyphicon-check': isCheck, 'glyphicon-unchecked': !isCheck}" style="display:inline"></span> <span style="display:inline;"><slot></slot></span>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        data: function(){
            return {
                isCheck: this.value
            }
        },
        methods: {
            onChecked: function(){
                this.isCheck = !this.isCheck
                this.$emit('input',this.isCheck)
            }
        },
        watch: {
            value: function(newVal, oldVal){
                this.isCheck = newVal
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/Checkbox.vue